<template>
    <div :class="`col-auto text-${direction}`">
      <div v-if="hasNumber">
        <div
          v-if="!isMenu"
          class="h4 font-weight-bold mb-1"
          :style="itemColor"
        > {{ numberText }} </div>
        <div
          v-if="!isMenu"
          class="text-xs font-weight-bold mb-1"
          :style="itemColor"
        > {{ subtitleText }} </div>
      </div>
      <div v-if="!isMenu">
        <div class="text-md font-weight-bold mb-1" :key="information" v-for="information in informations">
          {{ information }}
        </div>
        <slot></slot>
      </div>
    </div>
</template>

<script>

export default {
  props: {
    number: { required: true, type: Number },
    hasNumber: { required: true, type: Boolean },
    colorClass: { required: false, type: String, default: 'text-primary' },
    subtitle: { required: false, type: String },
    isMenu: { required: true, type: Boolean },
    selected: { required: true, type: Boolean },
    color: { required: true, type: String, default: '#0720E0' },
    informations: { required: false, type: Array, default: () => [] },
    links: { required: false, type: Array, default: () => [] },
    direction: { required: false, type: String, default: 'right' }
  },

  data () {
    return {
      subtitleText: '',
      numberText: ''
    }
  },

  created () {
    this.subtitleText = this.subtitle
    this.numberText = this.number
  },

  computed: {
    itemColor: function () {
      return {
        color: this.color
      }
    }
  },

  watch: {
    selected (newValue, oldValue) {
      this.subtitleText = ''
      this.numberText = ''
      setTimeout(() => {
        this.subtitleText = this.subtitle
        this.numberText = this.number
      }, 400)
    }
  }
}
</script>

<style scoped lang="scss">
</style>
